import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";

const processStatusAPI = createApi({
    reducerPath: 'processStatusAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        addEditConfigStatus: builder.mutation({
            query: (Details) => ({
                url: '/Status/AddEditConfigStatus',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getStatusByProcessStatusId: builder.query({
            query: (processStatusId) => ({
                url: encryptQueryString(`/Status/GetStatusByProcessStatusId/?processStatusId=${Number(processStatusId)}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

       
    })
})

export const { useAddEditConfigStatusMutation, useLazyGetStatusByProcessStatusIdQuery,} = processStatusAPI;

export default processStatusAPI;